import reduxConnector from 'root/src/shared/util/reduxConnector'

import commentDataSelector from 'root/src/client/logic/comment/selectors/commentDataSelector'
import userIdSelector from 'root/src/client/logic/auth/selectors/userIdSelector'
import isAdminSelector from 'root/src/client/logic/auth/selectors/isAdminSelector'
import getUserDataSelector from 'root/src/client/logic/api/selectors/getUserDataSelector'
import isMobileResSelector from 'root/src/client/logic/app/selectors/isMobileResSelector'
import isAuthenticated from 'root/src/client/logic/auth/selectors/isAuthenticated'

import auditCommentLikes from 'root/src/client/logic/comment/thunks/auditCommentLikes'
import deleteComment from 'root/src/client/logic/comment/thunks/deleteComment'
import addCommentReply from 'root/src/client/logic/comment/thunks/addCommentReply'
import getCommentReplies from 'root/src/client/logic/comment/thunks/getCommentReplies'

export default reduxConnector(
	[
		['commentData', commentDataSelector],
		['userId', userIdSelector],
		['isAdmin', isAdminSelector],
		['userData', getUserDataSelector],
		['isAuthenticated', isAuthenticated],
		['isMobileRes', isMobileResSelector],
	],
	[
		['auditCommentLikes', auditCommentLikes],
		['deleteComment', deleteComment],
		['addCommentReply', addCommentReply],
		['getCommentReplies', getCommentReplies],
	],
)
